module.exports = __webpack_public_path__ + "css/TryStar.ed95eb60.css";